import { render, staticRenderFns } from "./GiftIcon.vue?vue&type=template&id=73e0658e&scoped=true&"
import script from "./GiftIcon.vue?vue&type=script&lang=js&"
export * from "./GiftIcon.vue?vue&type=script&lang=js&"
import style0 from "./GiftIcon.vue?vue&type=style&index=0&id=73e0658e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e0658e",
  null
  
)

export default component.exports